import * as RadixSelect from "@radix-ui/react-select";
import { useTranslation } from "next-i18next";
import { ForwardedRef, forwardRef } from "react";
import { FiChevronDown } from "react-icons/fi";
import { WithClassName } from "../../helper/util";
import { robotoCondensed } from "@/pages/_app";

interface SelectProps extends WithClassName {
  value?: string;
  id?: string;
  name?: string;
  onChange?: (e: any) => void;
}
const SelectComponent = (
  { className, children, onChange, id, name, ...rest }: SelectProps,
  ref: ForwardedRef<any>
) => {
  const { t } = useTranslation();
  return (
    <RadixSelect.Root name={name} onValueChange={onChange} {...rest}>
      <RadixSelect.Trigger
        className={`selectTrigger ${className ?? ""}`}
        name={name}
        ref={ref}
        id={id}
      >
        <RadixSelect.Value defaultValue={rest.value} />
        {rest.value == undefined && t("Form_Select_Value")}
        <RadixSelect.Icon className="select-icon">
          <FiChevronDown className="ml-2 text-xl align-bottom" />
        </RadixSelect.Icon>
      </RadixSelect.Trigger>
      <RadixSelect.Portal style={robotoCondensed.style}>
        <RadixSelect.Content className="z-50">
          <RadixSelect.Viewport>
            <RadixSelect.Group className="selectViewport">
              {children}
            </RadixSelect.Group>
          </RadixSelect.Viewport>
        </RadixSelect.Content>
      </RadixSelect.Portal>
    </RadixSelect.Root>
  );
};

export const Select = forwardRef(SelectComponent);
interface OptionProps extends WithClassName {
  value: string;
}
const OptionComponent = (
  { children, className, ...props }: OptionProps,
  ref: ForwardedRef<any>
) => (
  <RadixSelect.Item className={`${className ?? ""}`} {...props} ref={ref}>
    <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
  </RadixSelect.Item>
);

export const Option = forwardRef(OptionComponent);
